import React from 'react'

import styles from './Modal.module.css'

export default function Modal({ children, onClose }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.modal}>{children}</div>
    </div>
  )
}
